/**
 * 사이트 신원 — 검색엔진·AI 크롤러에게 말하는 「누가 만든 무엇」.
 *
 * JSON-LD(Organization·WebSite·BlogPosting 의 publisher) 가 읽는다. 꼬리말
 * (`layouts/main/footer.tsx`)이 같은 회사 정보를 표시하지만 그쪽은 라벨이 붙은 화면 문구다.
 */

import { COLLECTION_CHANNELS } from 'src/constants/collection-channels';

export const SITE_URL = 'https://catchmoments.ai';
export const SITE_NAME = '캐치모먼츠';
export const SITE_NAME_EN = 'CatchMoments';

/**
 * 페이지가 따로 주지 않을 때의 공유 미리보기 이미지(OG·트위터 카드) — `app/og-image.png/route.tsx` 가 빌드 때 그린다.
 * ⚠️ 첫 화면 큰 질문(`FIND_LANDING_HEADLINE`)을 바꾸면 이 그림도 같이 바뀐다 — 카카오톡은 미리보기를 오래 붙들어 두므로 바꾼 뒤 캐시를 비운다.
 */
export const DEFAULT_OG_IMAGE = '/og-image.png';

/** `DEFAULT_OG_IMAGE` 의 크기 — 링크 미리보기가 큰 카드로 서는 1.91:1 */
export const DEFAULT_OG_IMAGE_SIZE = { width: 1200, height: 630 } as const;

/**
 * 사이트 대표 제목 — 첫 화면 `/` 의 머리 정보이자 제 머리 정보가 없는 페이지의 공유 미리보기 제목.
 * ⚠️ 뒷부분은 첫 화면 큰 질문(`FIND_LANDING_HEADLINE`)과 같은 말이다 — 시험이 둘을 맞춰 본다.
 */
export const SITE_TITLE = `${SITE_NAME} | 뷰티 레퍼런스, 검색 한 번으로 끝`;

/** 사이트 대표 설명 — `SITE_TITLE` 과 같은 자리에 쓴다(검색 결과·링크 미리보기·JSON-LD·llms.txt) */
export const SITE_DESCRIPTION = `인스타그램·틱톡·유튜브 등 ${COLLECTION_CHANNELS.length}개 채널의 뷰티 글부터 경쟁사 Meta 광고, 국내외 판매몰 랭킹, 이벤트까지. 물어보면 실제 데이터로 답해 드려요. 뜨는 컨텐츠·크리에이터·브랜드 랭킹도 한 화면에서 봐요.`;

/** JSON-LD 노드끼리 서로 가리키는 Organization 의 `@id` */
export const ORGANIZATION_ID = `${SITE_URL}/#organization`;

export const ORGANIZATION = {
  name: '(주)빌드업랩스',
  email: 'official@builduplabs.kr',
  /** 국제 표기 — 화면은 070.4138.0266 */
  telephone: '+82-70-4138-0266',
  logoUrl: `${SITE_URL}/logo/logo-single.png`,
  address: {
    streetAddress: '경인로 775, 4동 419호',
    addressLocality: '영등포구',
    addressRegion: '서울특별시',
    addressCountry: 'KR',
  },
  /** 같은 주체가 운영하는 다른 주소 — 문의 창구 */
  sameAs: ['https://catchmoments.channel.io'],
} as const;
